<template>
  <div class="comment4video">
    <textarea
      resizable="false"
      placeholder="欢迎分享交流，您的留言将由作者筛选后显示"
      v-model="content"/>

    <commit
      class="commit"
      width="650"
      @click.native="submit"
    >
      发表留言
    </commit>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/comment4video'
import moduleComment from '../modules/comment'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Button from '../components/UI/Button'

const moduleCommentPath = `${module.name}/${moduleComment.name}`

export default {
  components: {
    commit: Button
  },

  data () {
    return {
      content: ''
    }
  },

  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters)),
    ...mapState(moduleCommentPath, keys(moduleComment.state()))
  },

  watch: {
    submited (n) {
      console.log(n)
      if (n) {
        this.$router.back()
      }
    }
  },

  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapMutations(moduleCommentPath, keys(moduleComment.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    ...mapActions(moduleCommentPath, keys(moduleComment.actions)),

    submit () {
      this.sendFromComment4Video(this.content)
    }
  },

  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },

  created () {
    this.setChapterId(this.$route.query.chapterId)
  },

  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  }
}
</script>

<style lang="scss" scoped>
@charset "UTF-8";
@import "../style/main";

.comment4video {
  height: 100%;
  width: 100%;
  background-color: #F3F4F6;

  textarea {
    height: rem(400);
    width: 100%;
    padding: rem(29) rem(40) rem(30) rem(29);
    margin-bottom: rem(64);
    box-sizing: border-box;
    background-color: #fff;

    &::-webkit-input-placeholder {
      color: #666;
      font-size: rem(28);
    }
  }

  .commit {
    margin: 0 auto;
  }
}
</style>
